import React from 'react'
import _ from 'lodash'
import { ROUTES } from '../../../navigation/route-constants'
import LOCALE from '../../MovieListLocale'
import MovieInfo from '../../../movie/MovieInfo'
import Poster from '../../../movie/Poster'
import moment from 'moment'


export default class Multibio_FutureMoviesListItem extends React.Component {
    constructor(props) {
        super(props);
        this.movieClicked = this.movieClicked.bind(this);
    }

    movieClicked(e) {
        const { movieClicked } = this.props;
        const dataset = e.target.dataset;
        e.preventDefault();

        const movieId = e.currentTarget.id || dataset.movieId;
        if (e.target.tagName == 'IMG' || e.target.tagName == 'H1' || e.target.tagName == 'INPUT' || _.includes(e.target.classList, 'poster-banner'))
            movieClicked(movieId);
    }

    generateShowtimeSchedules() {
        const { movie, showtimeClicked, appLocale, organizers, showExpired, filterIds, movies, output, brand } = this.props;
       
        let showtimeSchedules = [];

        if (movie.showtimesByOrgId) {

            //_.forOwn(movie.showtimesByOrgId, (showtimes, orgId) => {
            //    if (showtimes.length > 0) {
            //        const isMultiBio = organizers.length > 1;

            //        const orgName = _.find(organizers, (org) => { return org.id == orgId });

            //        showtimeSchedules.push(
            //            <div key={orgId} className="organizer">
            //                {isMultiBio && orgName ? <h3 >{orgName.name}</h3> : null}

            //                <ShowtimeSchedulev2 movie={{ ...movie, validShowtimes: showtimes }}
            //                    showtimeClicked={showtimeClicked}
            //                    appLocale={appLocale}
            //                    showExpired={showExpired}
            //                    filterIds={filterIds}
            //                    output={this.output}

            //                />

            //                <hr style={{ width: '100 %', opacity: '0.1', margin: '20px 0px  20px ' }} ></hr>

            //            </div>);
            //    }
            //});
        }



        return showtimeSchedules;


    }

    render() {
        const { movie, rowClasses, appLocale, organizerIds, organizers, hasShowtimes, columns  } = this.props;
       
        const poster = movie.posters ?
            <a className="poster-container" href={`${window.location.origin}${ROUTES.MOVIEV2}/${movie.id}?org=${organizerIds}`}>
                <Poster movie={movie} /></a> : null;

        const movieNameLocale = movie.names ? (movie.names[appLocale] ? movie.names[appLocale] : movie.names['da']) : movie.name;

        const availableInOrganizers = _.map(movie.organizerId, (orgId) => {
            const organizer = _.find(organizers, { id: orgId });
            return <div key={organizer.id} className="organizer" style={{ borderRight: 'none', marginRight: 'none' }}>
                <h3 style={{ background: 'none' ,padding:0}}>{organizer.name}</h3></div>
        });
        const isDefault = moment(movie.openingDate).isSame(moment('1600-01-01'), 'date');

        const premiere = movie.openingDate && !isDefault ? <p className="premiere"><span>Premiere: </span><label>{moment(movie.openingDate).format('LL')}</label></p> : null;
        const genre = movie.genre ? <p className='genre'><label>{movie.genre}</label></p> : null;
        const description = movie.description ? <p key={movie.id} className="description" dangerouslySetInnerHTML={{ __html: movie.description.replace(/(?:\r\n|\r|\n)/g, '<br />') }} /> : null; 

        return (
            <div className={rowClasses} id={movie.id} onClick={this.movieClicked} >
                {poster}
                < div className="movie-info" >
                    <div className="flex-container available-organizers">
                        {availableInOrganizers}
                    </div>
                    <a  href={`${window.location.origin}${ROUTES.MOVIEV2}/${movie.id}?org=${organizerIds}`}>
                        <h1 style={{ marginTop: '10px' }} className='movie-name'>{movieNameLocale}</h1></a>

                    <div className="future-info">
                        {premiere}
                        {genre}
                        {description }
                        {/*<MovieInfo movie={movie} showTitle={false} appLocale={appLocale} />*/}
                        <div className="read-more future" style={{ marginTop: '0px' }}><input style={{marginLeft:0}} type="button" className="next" data-movie-id={movie.id} value={hasShowtimes ? LOCALE[appLocale].buyTickets : LOCALE[appLocale].readMore} /></div>
                    </div>
                </div>
            </div >
        )
    }
}